import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';

import { TYTCommonModule } from '@tytapp/common';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { UserModule } from '@tytapp/user';

import { ShowComponent } from './show/show.component';
import { ShowsPageComponent } from './shows-page/shows-page.component';

import { routing } from './show-pages.routing';
import { CommonUiModule } from '@tytapp/common-ui';
import { ArticlesModule } from '@tytapp/articles';
import { SocialModule } from '@tytapp/social';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { AllMediaComponent } from './all-media/all-media.component';
import { ShowsModule } from '@tytapp/shows';
import { LiveStreamsModule } from '@tytapp/live-streams';

@NgModule({
    imports: [
        FormsModule,
        ACommonModule,
        TYTCommonModule,
        CommonUiModule,
        UserModule,
        MediaPlaybackModule,
        ArticlesModule,
        ShowsModule,
        LiveStreamsModule,
        SocialModule,
        MatIconModule,
        MatButtonModule,
        MatTabsModule,
        MatMenuModule,

        routing,
        MatButtonModule
    ],
    declarations: [
        ShowComponent,
        ShowsPageComponent,
        AllMediaComponent
    ],
    exports: [
        ShowComponent,
        ShowsPageComponent
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ShowPagesModule {
    static forRoot(): ModuleWithProviders<ShowPagesModule> {
        return {
            ngModule: ShowPagesModule,
            providers: []
        };
    }
}
